import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { AuthShell } from "@/components/AuthShell";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState(token ? "loading" : "error");
  const [msg, setMsg] = useState(token ? "" : "This verification link is missing its token.");
  const ran = useRef(false);

  useEffect(() => {
    if (!token || ran.current) return;
    ran.current = true;
    api.post("/auth/verify-email", { token })
      .then(({ data }) => { setState("ok"); setMsg(data.message); })
      .catch((err) => { setState("error"); setMsg(apiError(err.response?.data?.detail)); });
  }, [token]);

  return (
    <AuthShell title="Email verification" subtitle="Activating your Skanovix HR portal account.">
      <div className="rounded-xl border border-border p-6 space-y-3" data-testid="verify-status">
        {state === "loading" && <Loader2 className="w-8 h-8 animate-spin text-primary" />}
        {state === "ok" && <CheckCircle2 className="w-8 h-8 text-accent" />}
        {state === "error" && <XCircle className="w-8 h-8 text-destructive" />}
        <p className="font-semibold" data-testid="verify-message">{state === "loading" ? "Verifying…" : msg}</p>
        {state !== "loading" && (
          <Link to="/login" className="text-sm text-primary underline" data-testid="verify-login-link">Go to sign in</Link>
        )}
      </div>
    </AuthShell>
  );
}
